import * as moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import {
  change,
  formValueSelector,
  InjectedFormProps,
  reduxForm
} from 'redux-form'
import SnackbarService from '../../services/snackbars'
import * as PatientActions from '../../store/patients/actions'
import Content from './content'

import { CropImage } from 'components'

import './style.scss'

import { _route } from '../../routes/config'

export interface IProps extends RouteComponentProps, InjectedFormProps {
  currentPatient: any
  user: any
  changeFieldValue: any
  PatientsLib: any
  patientDetails: any
}

export interface IState {
  page: string
  image: string
  croppedImage: string
  loading: boolean
}

class EditPatient extends React.PureComponent<IProps, IState> {
  state = {
    page: 'edit-patient',
    image: '',
    croppedImage: this.props.currentPatient.patient_avatar,
    loading: false
  }

  handleFiles = ({ base64 }) => {
    const { page } = this.state

    if (page === 'edit-patient' && base64.includes('image')) {
      this.setState({ page: 'crop-avatar', image: base64 })
    }
  }

  onSubmitChanges = () => {
    const { valid, PatientsLib } = this.props
    const { croppedImage } = this.state
    if (!valid) {
      SnackbarService.showSnackbar('Invalid Form!', 'error')
      return
    }
    this.setState({ loading: true })
    if (typeof croppedImage === 'string') {
      this.editPatient(croppedImage)
    } else {
      PatientsLib.uploadImage(croppedImage, this.editPatient, message => {
        console.log('onedit message', typeof message)
        SnackbarService.showSnackbar(message, 'error')
        this.setState({ loading: false })
      })
    }
  }

  editPatient = avatarUrl => {
    const {
      patientDetails,
      currentPatient: { patientId },
      PatientsLib,
      history
    } = this.props
    const patientData = {
      birth_date: moment(patientDetails.dateOfBirth).unix(),
      first_name: patientDetails.first_name,
      patient_avatar: avatarUrl
    }
    PatientsLib.editPatient(patientData, patientId)
      .then(data => {
        this.setState({ loading: false })
        history.goBack()
      })
      .catch(message => {
        console.log('onedit message', Object.keys(message))
        SnackbarService.showSnackbar(message, 'error')
        this.setState({ loading: false })
      })
  }

  onSubmitCrop = image => {
    console.log('onedit received', image)
    this.setState({ page: 'edit-patient', croppedImage: image })
  }

  onCancelCrop = () => {
    console.log('onedit cancelled crop')
    this.setState({ page: 'edit-patient' })
  }

  componentDidMount() {
    const { changeFieldValue, currentPatient } = this.props
    const [firstName] = currentPatient
    const date = moment.unix(currentPatient.birth_date).format('YYYY-MM-DD')

    changeFieldValue('firstName', firstName)
    changeFieldValue('dateOfBirth', date)
  }

  render() {
    const { currentPatient, valid } = this.props
    const { image, page, croppedImage, loading } = this.state
    return (
      <React.Fragment>
        {page === 'edit-patient' ? (
          <Content
            currentPatient={currentPatient}
            croppedImage={croppedImage}
            handleFiles={this.handleFiles}
            onSubmit={this.onSubmitChanges}
            loading={loading}
            valid={valid}
          />
        ) : (
          <CropImage
            onSubmit={this.onSubmitCrop}
            onCancel={this.onCancelCrop}
            image={image}
          />
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const patientDetails = {
    first_name: selector(state, 'firstName') || '',
    bitrh_date: selector(state, 'dateOfBirth') || ''
  }

  return {
    patientDetails,
    user: state.user.data,
    currentPatient: state.patients.currentPatient
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeFieldValue: (field, value) => dispatch(change(form, field, value)),
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

function EditPatientContainer(props: IProps) {
  const { currentPatient, history, user, match } = props
  if (!user) {
    history.push('/')
    return <div />
  }
  if (!currentPatient) {
    history.push(_route.patient.list)
    return <div />
  } else {
    const patientId = (match.params as any).id
    if (patientId !== currentPatient.patientId) {
      history.push(_route.patient.list)
      return <div />
    }
    return <EditPatient {...props} />
  }
}

const form = 'editChild'

const EditPatientWithForm = reduxForm({
  form
})(EditPatientContainer)

const selector = formValueSelector(form)

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditPatientWithForm) as React.ElementType<RouteComponentProps>
)



// WEBPACK FOOTER //
// ./src/pages/EditPatient/index.tsx